module.exports = __webpack_public_path__ + "img/yaoshi_zhongji-11.9058d21f.png";